__turbopack_context__.v({
  "blok-big-title": "ArticlePageBlok-module__OGsSqq__blok-big-title",
  "blok-subtitle": "ArticlePageBlok-module__OGsSqq__blok-subtitle",
  "blok-title": "ArticlePageBlok-module__OGsSqq__blok-title",
  "hero": "ArticlePageBlok-module__OGsSqq__hero",
  "hero__heading": "ArticlePageBlok-module__OGsSqq__hero__heading",
  "hero__subtitle": "ArticlePageBlok-module__OGsSqq__hero__subtitle",
  "mainImage": "ArticlePageBlok-module__OGsSqq__mainImage",
});
